<template>
  <div v-if="shown" class="pr-6 pl-12 mt-4">
    <zt-alert :color="status" close-icon filled class="table-message" @afterClosed="hideMessage">
      <div slot="custom-content">
        <div class="flex justify-start items-center py-4 px-2">
          <zt-icon v-if="iconName" :name="iconName" class="icon mr-4"></zt-icon>
          <p>{{message}}</p>
        </div>
      </div>
    </zt-alert>
  </div>
</template>
<script>
const icons = {
  'danger': 'exclamation-circle-solid',
  'warning': 'warning-circle-solid',
  'info': 'info-circle-solid'
}
export default {
  name: "SearchTableMessages",
  inject: ['hideMessage'],
  props: {
    shown: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'danger'
    },
    message: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return icons[this.status]
    }
  }
}
</script>
<style scoped lang="scss">
.icon { font-size: 2rem; }
p { font-size: 1rem; }
::v-deep {
  .table-message .zt-icon-times {
    margin-top: 16px;
  }
}
</style>